export default __webpack_public_path__ + "static/media/G6PS_150.8046d0a1.jpg";